<template>
  <v-layout
    row
    wrap
    class="text-xs-center align-content-center"
    fill-height
  >
    <v-flex xs12>
      <v-progress-circular
        v-if="loading"
        indeterminate
        size="60"
        color="primary"
      />
    </v-flex>

    <v-flex
      v-if="!loading"
      xs10
      offset-xs1
      offset-sm3
      sm6
      md4
      offset-md4
      :mt-3="$vuetify.breakpoint.xsOnly"
    >
      <v-form v-model="valid">
        <h3>Cobertura*</h3>
        <v-autocomplete
          v-model="selected.selectedCobertura"
          clearable
          :disabled="loading2"
          :items="coberturas"
          item-text="nombre"
          return-object
          primary
          placeholder="Seleccionar Obra Social y Plan"
        />

        <h3>Sucursal</h3>
        <v-autocomplete
          v-model="selected.selectedSucursal"
          clearable
          :disabled="loading2"
          :items="sucursales"
          item-text="nombre"
          item-value="sucursal"
          primary
          placeholder="Sin Preferencia"
        />

        <h3>Especialidad</h3>
        <v-autocomplete
          v-model="selected.selectedEspecialidad"
          clearable
          :disabled="loading2"
          :items="especialidades"
          item-text="nombre"
          item-value="especialidad"
          primary
          placeholder="Sin Preferencia"
          @click:clear="cleanForm"
        />

        <h3>Prestacion*</h3>
        <v-autocomplete
          v-model="selected.selectedPrestacion"
          clearable
          :disabled="loading2"
          :items="prestaciones"
          item-text="nombre"
          return-object
          primary
          placeholder="Seleccionar Prestacion"
        />

        <h3>Profesional</h3>
        <v-autocomplete
          v-model="selected.selectedProfesional"
          clearable
          :disabled="loading2"
          :items="profesionales"
          item-text="nombre"
          item-value="profesional"
          primary
          placeholder="Sin Preferencia"
        />

        <div class="text-xs-right">
          <v-btn
            :disabled="isValid"
            :block="$vuetify.breakpoint.xsOnly"
            :loading="loading2"
            large
            class="mt-4 primary mb-2"
            @click="getTurnos"
          >
            Buscar Turnos
          </v-btn>
        </div>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
import {
  getCoberturas,
  getEspecialidades,
  getSucursales,
  getPrestaciones,
  getProfesionales,
  getTurnosCalendario
} from '../api/appointmentsEndpoints'
import { mapGetters } from 'vuex'

export default {
  name: 'AppointmentView',
  data () {
    return {
      loading: false,
      loading2: false,
      valid: false,
      coberturas: [],
      sucursales: [],
      especialidades: [],
      prestaciones: [],
      profesionales: [],
      selected: {
        selectedCobertura: null,
        selectedSucursal: null,
        selectedEspecialidad: null,
        selectedPrestacion: null,
        selectedProfesional: null
      }
    }
  },
  computed: {
    ...mapGetters(['user', 'getSelectionParams']),
    isValid () {
      return !this.selected.selectedCobertura || !this.selected.selectedPrestacion
    }
  },
  watch: {
    async 'selected.selectedEspecialidad' (newValue) {
      if (newValue === null) {
        this.loading = true
        this.selected.selectedPrestacion = ''
        this.selected.selectedProfesional = ''
        this.prestaciones = await getPrestaciones()
        this.profesionales = await getProfesionales()
        this.loading = false
      } else {
        this.loading = true
        this.prestaciones = await getPrestaciones(newValue)
        this.profesionales = await getProfesionales(newValue)
        this.loading = false
      }
    }
  },
  async mounted () {
    await this.getAllData()
    if (this.getSelectionParams) {
      this.selected = { ...this.getSelectionParams }
    }
    if (this.user) {
      this.selected.selectedCobertura = this.coberturas.find(c => c.obraSocial === this.user.plan.obraSocial && c.plan === this.user.plan.plan)
    }
  },
  methods: {
    cleanForm () {
      this.selected.selectedProfesional = null
      this.selected.selectedPrestacion = null
    },
    async getAllData () {
      this.loading = true
      this.coberturas = await getCoberturas()
      this.sucursales = await getSucursales()
      this.especialidades = await getEspecialidades()
      this.prestaciones = await getPrestaciones()
      this.profesionales = await getProfesionales()
      this.loading = false
    },
    async getTurnos () {
      const params = {
        obraSocial: this.selected.selectedCobertura.obraSocial,
        plan: this.selected.selectedCobertura.plan,
        sucursal: this.selected.selectedSucursal,
        especialidad: this.selected.selectedEspecialidad,
        prestacion: this.selected.selectedPrestacion.prestacion,
        profesional: this.selected.selectedProfesional
      }
      this.loading2 = true
      this.isvalid = false
      await this.$store.dispatch('setSelection', this.selected)
      const turnos = await getTurnosCalendario(params)
      this.$router.push({ name: 'CalendarView', params: { params, turnos } })
    }
  }
}
</script>

<style scoped lang="sass">
h3
  text-align: left
  margin-top: 10px
.progress-circle
  margin: 40vh auto

</style>
